var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompareImages({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11C19.4965 8.63705 18.6004 6.36137 16.9887 4.62283C15.377 2.88429 13.1671 1.80943 10.7958 1.61071V0H9.21323V1.61071C6.83896 1.80377 4.62472 2.87664 3.01044 4.61617C1.39617 6.3557 0.5 8.63457 0.5 11C0.5 13.3654 1.39617 15.6443 3.01044 17.3838C4.62472 19.1234 6.83896 20.1962 9.21323 20.3893V22H10.7958V20.3893C13.1671 20.1906 15.377 19.1157 16.9887 17.3772C18.6004 15.6386 19.4965 13.363 19.5 11ZM10.0045 18.8571V3.14286C12.1032 3.14286 14.1158 3.97066 15.5998 5.44416C17.0837 6.91766 17.9174 8.91616 17.9174 11C17.9174 13.0838 17.0837 15.0823 15.5998 16.5558C14.1158 18.0293 12.1032 18.8571 10.0045 18.8571Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareImages);
export default __webpack_public_path__ + "static/media/compare-images.fd51f260.svg";
export { ForwardRef as ReactComponent };